var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-pop-cell"},[_c('div',{staticClass:"pop"},[_c('BluePop',{attrs:{"large":"","text":_vm.text,"use-default-temp":false}},[_c('div',{staticClass:"content-row",attrs:{"slot":"temp"},slot:"temp"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])],1),_c('div',{staticClass:"block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }